import type { Bilingual, Locale } from '@/types/content'
import type { UiStrings } from '@/constants/i18n'

import { useRouter } from 'next/router'
import { defaultLocale, ui } from '@/constants/i18n'

export const toLocale = (value?: string): Locale => (value === 'hi' ? 'hi' : defaultLocale)

export const pick = (value: Bilingual | undefined, locale: Locale): string => {
    if (!value) return ''
    return value[locale] || value.en
}

export const useLocale = (): { locale: Locale, other: Locale, t: UiStrings, tx: (value?: Bilingual) => string } => {
    const router = useRouter()
    const locale = toLocale(router.locale)
    const other: Locale = locale === 'en' ? 'hi' : 'en'

    return {
        locale,
        other,
        t: ui[locale],
        tx: (value?: Bilingual) => pick(value, locale)
    }
}
